<mat-card class="crud-search-card">
  <mat-card-title>{{composedAssetClassParameter}} Maintenance</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">
        <mat-form-field *ngIf="assetIdParameter != null" matTooltip="Asset"
          [matTooltipDisabled]="disabledTooltip(this.assetId)">
          <mat-label i18n="@@type.AssetMaintenance.asset">Asset</mat-label>
          <input matInput formControlName="assetId" id="assetIdFilterInput" [value]="assetIdFilter" placeholder="Asset">
        </mat-form-field>
        <mat-form-field *ngIf="assetIdParameter == null" matTooltip="Asset Id"
          [matTooltipDisabled]="disabledTooltip(this.assetId)">
          <mat-label i18n="@@type.AssetMaintenance.assetId">Asset Id</mat-label>
          <input matInput formControlName="assetId" id="assetIdFilterInput" (ngModelChange)="assetIdChanging($event)"
            [(ngModel)]="assetIdFilter" (ngModelChange)="assetIdChanged($event)" #assetIdFilterInput type="number"
            placeholder="Asset Id">
        </mat-form-field>
      </div>
      <div class="search-section">
        <mat-form-field matTooltip="Select a Maintenance Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.maintenanceType)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceType">Maintenance Type</mat-label>
          <mat-select formControlName="maintenanceType" id="maintenanceTypeFilterInput"
            (ngModelChange)="maintenanceTypeChanging($event)" [(ngModel)]="maintenanceTypeFilter"
            (ngModelChange)="maintenanceTypeChanged($event)" #maintenanceTypeFilterInput placeholder="Maintenance Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceType of maintenanceTypeSelectionList" [value]="maintenanceType.code">
              {{maintenanceType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Maintenance By" [matTooltipDisabled]="disabledTooltip(this.maintenanceBy)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceBy">Maintenance By</mat-label>
          <input matInput formControlName="maintenanceBy" id="maintenanceByFilterInput"
            (ngModelChange)="maintenanceByChanging($event)" [(ngModel)]="maintenanceByFilter"
            (ngModelChange)="maintenanceByChanged($event)" #maintenanceByFilterInput maxlength="255"
            placeholder="Maintenance By">
        </mat-form-field>

        <mat-form-field matTooltip="Maintenance Date From"
          [matTooltipDisabled]="disabledTooltip(this.maintenanceDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceDateGreaterThanOrEqualTo">Maintenance Date
            From</mat-label>
          <input matInput formControlName="maintenanceDateGreaterThanOrEqualTo"
            id="maintenanceDateGreaterThanOrEqualToFilterInput"
            (ngModelChange)="maintenanceDateGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="maintenanceDateGreaterThanOrEqualToFilter"
            (ngModelChange)="maintenanceDateGreaterThanOrEqualToChanged($event)"
            #maintenanceDateGreaterThanOrEqualToFilterInput
            [matDatepicker]="maintenanceDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Maintenance Date From">
          <mat-datepicker-toggle matSuffix
            [for]="maintenanceDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #maintenanceDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Maintenance Date To"
          [matTooltipDisabled]="disabledTooltip(this.maintenanceDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceDateLessThanOrEqualTo">Maintenance Date To</mat-label>
          <input matInput formControlName="maintenanceDateLessThanOrEqualTo"
            id="maintenanceDateLessThanOrEqualToFilterInput"
            (ngModelChange)="maintenanceDateLessThanOrEqualToChanging($event)"
            [(ngModel)]="maintenanceDateLessThanOrEqualToFilter"
            (ngModelChange)="maintenanceDateLessThanOrEqualToChanged($event)"
            #maintenanceDateLessThanOrEqualToFilterInput [matDatepicker]="maintenanceDateLessThanOrEqualToDatePicker"
            (dateChange)="maybeDoAutoSearch()" placeholder="Maintenance Date To">
          <mat-datepicker-toggle matSuffix [for]="maintenanceDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #maintenanceDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="search-section">
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.AssetMaintenance.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"
            (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"
            (ngModelChange)="createdByChanged($event)" #createdByFilterInput maxlength="255" placeholder="Created By">
        </mat-form-field>

        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.AssetMaintenance.comments">Comments</mat-label>
          <input matInput formControlName="comments" id="commentsFilterInput" (ngModelChange)="commentsChanging($event)"
            [(ngModel)]="commentsFilter" (ngModelChange)="commentsChanged($event)" #commentsFilterInput maxlength="1000"
            placeholder="Comments">
        </mat-form-field>

        <mat-form-field matTooltip="Created Date From"
          [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.AssetMaintenance.createdDateGreaterThanOrEqualTo">Created Date From</mat-label>
          <input matInput formControlName="createdDateGreaterThanOrEqualTo"
            id="createdDateGreaterThanOrEqualToFilterInput"
            (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="createdDateGreaterThanOrEqualToFilter"
            (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput
            [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Created Date From">
          <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Created Date To"
          [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.AssetMaintenance.createdDateLessThanOrEqualTo">Created Date To</mat-label>
          <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"
            (ngModelChange)="createdDateLessThanOrEqualToChanging($event)"
            [(ngModel)]="createdDateLessThanOrEqualToFilter"
            (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput
            [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Created Date To">
          <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="search-section">
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch" [ngModelOptions]="{standalone: true}">
          Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="assetMaintenanceId">
            <mat-header-cell [crud-column-header]="columns.column('assetMaintenanceId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.assetMaintenanceId">
              Asset Maintenance Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.assetMaintenanceId}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="assetId">
            <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.assetId">
              Asset Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.assetId}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.comments">
              Comments
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.createdBy">
              Created By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.createdDate">
              Created Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lockVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.lockVersion">
              Lock Version
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lockVersion | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceBy">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.maintenanceBy">
              Maintenance By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.maintenanceBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceDate">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.maintenanceDate">
              Maintenance Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.maintenanceDate | uimDateFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceType">
            <mat-header-cell [crud-column-header]="columns.column('maintenanceType')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.AssetMaintenance.maintenanceType">
              Maintenance Type
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.maintenanceType | refDecode:'MAINTENANCE_TYPE' | async}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>